import { gql } from "@apollo/client";

const COLLECTION = gql`
  query collection($filter: FindOneCollection!) {
    collection(filter: $filter) {
      __typename
      ... on Collection {
        id
        name
        description
        product {
          id
          name
          description
          price
          shine
          stock
        }
        url_image
        ref_image
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const COLLECTIONS = gql`
  query collections {
    collections {
      __typename
      ... on Collection {
        id
        name
        description
        product {
          id
          name
          description
          price
          shine
          stock
        }
        url_image
        ref_image
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const COLLECTIONS_ADMIN = gql`
  query collectionsAdmin {
    collectionsAdmin {
      __typename
      ... on Collection {
        id
        name
        description
        product {
          id
          name
          description
          price
          shine
          stock
          url_image
          ref_image
        }
        url_image
        ref_image
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export { COLLECTIONS, COLLECTION, COLLECTIONS_ADMIN };
